import ReactPixel from 'react-facebook-pixel'

export const trackGetApp = () =>
  ReactPixel.track('Get App Click', { value: 1, currency: 'USD' })
